import { render } from "./EditFormulario.vue?vue&type=template&id=c3952100&scoped=true"
import script from "./EditFormulario.vue?vue&type=script&lang=js"
export * from "./EditFormulario.vue?vue&type=script&lang=js"

import "./EditFormulario.vue?vue&type=style&index=0&id=c3952100&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3952100"]])

export default __exports__